<template>
    <div class="text-3xl">
        <span class="text-yellow">Mind</span>M
    </div>
</template>